import React from 'react';

const SectionSelectedPlaceSummary = ({ place, onClear }) => {
  if (!place) return null;
  return (
    <div className="container col-md-8 col-lg-6">
      <div className="bg-white border rounded shadow-sm p-3 my-3 d-flex flex-column">
        <div className="d-flex align-items-center flex-wrap mb-2">
          <span className="text-muted border rounded px-2 py-1 mr-2" style={{ fontSize: '12px' }}>
            選択中
          </span>
          <span className="text-fz-16px text-fw-bold mb-0 mt-1">{place.name}</span>
        </div>
        {place.description && (
          <p className="mb-1">
            <a href={place.description} target="_blank" rel="noopener noreferrer" className="text-primary small">
              {place.description.replace(/^https?:\/\//, '')}
            </a>
          </p>
        )}
        {place.address && (
          <p className="mb-1 text-muted small">{place.address}</p>
        )}
        {place.opening_hours && (
          <p className="mb-0 text-muted small">{place.opening_hours}</p>
        )}
        {onClear && (
          <div className="d-flex justify-content-end mt-1">
            <button type="button" className="btn btn-sm btn-outline-danger" onClick={onClear}>
              選択解除
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionSelectedPlaceSummary;
